module.exports = __webpack_public_path__ + "static/media/2 PIECE SUIT.5664a105.svg";